import { z } from 'zod';
import { planoCodigoSchema, recursoSchema, ESTAGIOS_LIBERACAO, GRUPOS_LIBERACAO } from './planos';
import { emailSchema } from './auth';

/** Admin cadastra uma loja nova; o dono recebe o convite para criar a senha. */
export const novaLojaSchema = z.object({
  nome: z.string().trim().min(2).max(120),
  /** Endereço do site (loja.seudominio): gerado do nome quando vazio */
  slug: z
    .string()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, 'Use letras minúsculas, números e hífen')
    .min(3)
    .max(40)
    .optional(),
  plano: planoCodigoSchema,
  /** 0 = já começa pagando */
  diasTeste: z.number().int().min(0).max(90).default(14),
  /** CNPJ da loja (só números), opcional no cadastro */
  cnpj: z
    .string()
    .regex(/^\d{14}$/, 'CNPJ com 14 números')
    .optional(),
  dono: z.object({ nome: z.string().trim().min(2).max(120), email: emailSchema }),
});
export type NovaLojaInput = z.infer<typeof novaLojaSchema>;

export const mudarPlanoSchema = z.object({ plano: planoCodigoSchema });
export const adicionaisSchema = z.object({ adicionais: z.array(recursoSchema) });
export const periodoTesteSchema = z.object({ dias: z.number().int().min(1).max(90) });
export const grupoLiberacaoSchema = z.object({ grupo: z.enum(GRUPOS_LIBERACAO) });

export const funcionalidadeSchema = z.object({
  desligada: z.boolean(),
  estagio: z.enum(ESTAGIOS_LIBERACAO),
  percentual: z.number().int().min(0).max(100),
});

export const avisoSchema = z.object({
  titulo: z.string().min(3).max(120),
  mensagem: z.string().min(3).max(2000),
  nivel: z.enum(['info', 'atencao', 'critico']),
  expiraEm: z.coerce.date().optional(),
});

export const autorizarSuporteSchema = z.object({ horas: z.number().int().min(1).max(72) });
